var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import warning from 'warning';
import Node from './Node';
import ToggleController from './ToggleController';
var Treefold = (_temp = _class = function (_Component) {
  _inherits(Treefold, _Component);

  function Treefold(props) {
    _classCallCheck(this, Treefold);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.internalRender = function (_ref) {
      var isOn = _ref.isOn,
          onToggle = _ref.onToggle;
      var _this$props = _this.props,
          nodes = _this$props.nodes,
          getNodeId = _this$props.getNodeId,
          getNodeChildren = _this$props.getNodeChildren;
      var render = getRenderProp(_this.props);
      return render ? nodes.map(function (node) {
        return React.createElement(Node, {
          key: getNodeId(node),
          node: node,
          render: render,
          getNodeId: getNodeId,
          getNodeChildren: getNodeChildren,
          isNodeExpanded: isOn,
          onToggleExpand: onToggle
        });
      }) : null;
    };

    checkProps(props);
    return _this;
  }

  Treefold.prototype.componentDidUpdate = function componentDidUpdate() {
    checkProps(this.props);
  };

  Treefold.prototype.render = function render() {
    var _props = this.props,
        isNodeExpanded = _props.isNodeExpanded,
        onToggleExpand = _props.onToggleExpand,
        getNodeId = _props.getNodeId;
    var isControlled = typeof isNodeExpanded === 'function' && typeof onToggleExpand === 'function';
    return isControlled ? this.internalRender({
      isOn: isNodeExpanded,
      onToggle: onToggleExpand
    }) : React.createElement(ToggleController, {
      getId: getNodeId
    }, this.internalRender);
  };

  return Treefold;
}(Component), _class.defaultProps = {
  getNodeId: function getNodeId(item) {
    return item.id;
  },
  getNodeChildren: function getNodeChildren(item) {
    return item.children;
  }
}, _temp);
Treefold.propTypes = process.env.NODE_ENV !== "production" ? {
  nodes: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  render: PropTypes.func,
  children: PropTypes.func,
  isNodeExpanded: PropTypes.func,
  onToggleExpand: PropTypes.func,
  getNodeId: PropTypes.func,
  getNodeChildren: PropTypes.func
} : {};

function getRenderProp(_ref2) {
  var render = _ref2.render,
      children = _ref2.children;
  return typeof render === 'function' ? render : typeof children === 'function' ? children : null;
}

function checkProps(_ref3) {
  var isNodeExpanded = _ref3.isNodeExpanded,
      onToggleExpand = _ref3.onToggleExpand,
      render = _ref3.render,
      children = _ref3.children;
  warning((typeof isNodeExpanded === 'undefined' ? 'undefined' : _typeof(isNodeExpanded)) === (typeof onToggleExpand === 'undefined' ? 'undefined' : _typeof(onToggleExpand)), 'Treefold: You must pass both isNodeExpanded and onToggleExpand, or none.');
  warning(!(typeof render === 'function' && typeof children === 'function'), 'You should not use <Treefold render /> and <Treefold>{children}</Treefold> in the same Treefold component; `children` will be ignored');
  warning(!(typeof render !== 'function' && typeof children !== 'function'), 'You should specify one of <Treefold render /> or <Treefold>{children}</Treefold>; your component will render nothing unless you do so');
}

export default Treefold;